import lang from '@/lang'
import { ComponentType, SVGProps } from 'react'
import { SIGNATURE_FIELD_TYPES } from '@/modules/base/util/constants'
import SignaturePenIcon from '@assets/images/icons/signature_pen.svg'
import CalendarIcon from '@assets/images/icons/calendar.svg'
import TextIcon from '@assets/images/icons/v2/text-indicator.svg'
import { SignatureItem } from '@/modules/signature/types'

export const getFieldTypeInfo = (signatureItem: SignatureItem): { icon: ComponentType<SVGProps<SVGSVGElement>>, label: string } => {
  const { type, description } = signatureItem

  switch (type) {
    case SIGNATURE_FIELD_TYPES.DATE: {
      return {
        icon: CalendarIcon,
        label: lang.signature.date,
      }
    }
    case SIGNATURE_FIELD_TYPES.TEXT: {
      return {
        icon: TextIcon,
        label: description || lang.signature.text,
      }
    }
    default: {
      return {
        icon: SignaturePenIcon,
        label: lang.signature.signature,
      }
    }
  }
}
